<script setup lang="ts">
const {
  cameras,
  currentCamera,
  microphones,
  currentMicrophone,
  speakers,
  stream,
  enabled,
  currentSpeaker,
} = useMediaSettings({
  enableMicrophone: true,
})

const { pulse } = useAudioAnalyzer(stream, {
  enablePulse: true,
})

const { storage, toggleSectionMediaSettings } = useRoomSettings()
const preferences = storage.value.preferences

watch(() => preferences.isMicrophone, (value) => {
  if (value) {
    enabled.value = true
  }
  else {
    enabled.value = false
  }
}, { immediate: true })
</script>

<template>
  <div class="relative h-full w-full overflow-auto px-1 py-2 space-y-12">
    <div class="flex items-center justify-between">
      <h4 class="text-lg font-semibold">
        Configure Media
      </h4>

      <GButton
        label="i-close"
        icon
        btn="text-gray"
        class="p-0"
        @click="toggleSectionMediaSettings(false)"
      />
    </div>

    <div class="space-y-5">
      <h5 class="font-semibold">
        Video Settings
      </h5>
      <div class="space-y-3">
        <div class="flex flex-col gap-y-3">
          <GFormGroup
            label="Camera Device"
          >
            <GSelect
              v-model="currentCamera"
              item-attribute="label"
              placeholder="Select Camera Device"
              :items="cameras"
            />
          </GFormGroup>
        </div>

        <GLabel class="flex items-center font-normal">
          <GSwitch
            v-model:checked="preferences.isCamera"
          />

          <span class="ml-2">
            Enable Camera
          </span>
        </GLabel>

        <GLabel class="flex items-center font-normal">
          <GSwitch
            v-model:checked="preferences.isMirror"
          />

          <span class="ml-2">
            Mirror Camera
          </span>
        </GLabel>

        <GLabel
          v-if="preferences.isCamera"
          class="flex items-center font-normal"
        >
          <GSwitch
            v-model:checked="preferences.isVirtualBackground"
          />

          <span class="ml-2">
            Virtual Background
          </span>
        </GLabel>

        <div v-if="preferences.isVirtualBackground && preferences.isCamera">
          <CommonVirtualBackgroundSelect
            v-model="preferences.cameraVirtualBackground"
          />
        </div>
      </div>
    </div>

    <div class="space-y-5">
      <h5 class="font-semibold">
        Audio Settings
      </h5>

      <div class="space-y-6">
        <div class="space-y-3">
          <div class="flex flex-col gap-y-3">
            <GFormGroup
              label="Microphone Device"
            >
              <GSelect
                v-model="currentMicrophone"
                item-attribute="label"
                placeholder="Select Microphone Device"
                :items="microphones"
              />
            </GFormGroup>
          </div>

          <GLabel class="flex items-center font-normal">
            <GSwitch
              v-model:checked="preferences.isMicrophone"
            />

            <span class="ml-2">
              Enable Microphone
            </span>
          </GLabel>
        </div>

        <GFormGroup
          label="Audio Input Level"
        >
          <GProgress
            :model-value="pulse"
          />
        </GFormGroup>

        <!-- Hide this for now, let User choose from native settings. -->
        <div
          v-if="false"
          class="space-y-3"
        >
          <div class="flex flex-col gap-y-3">
            <GFormGroup
              label="Speaker Device"
            >
              <GSelect
                v-model="currentSpeaker"
                item-attribute="label"
                placeholder="Select Speaker Device"
                :items="speakers"
              />
            </GFormGroup>
          </div>

          <GLabel class="flex items-center font-normal">
            <GSwitch
              v-model:checked="preferences.isSpeaker"
            />

            <span class="ml-2">
              Enable Speaker
            </span>
          </GLabel>
        </div>
      </div>
    </div>
  </div>
</template>
